import { useAsync } from "lib/@hooks/useAsync"
import { ConditionValueSetPicker } from "./condition-value-set-picker"
import { getCoreTags } from "./controller/get-core-tags"

export function ConditionValueScheduleTags({ value, onChange }) {
    const tags = useAsync(loadTags, [], [])

    return (
        <ConditionValueSetPicker
            value={value}
            onChange={onChange}
            options={tags}
            placeholder="Select schedule tags..."
        />
    )

    async function loadTags() {
        return (await getCoreTags()) || []
    }
}
